// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
var createNewGuid = function createNewGuid() {
  var s4 = function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };

  return "".concat(s4()).concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4(), "-").concat(s4()).concat(s4()).concat(s4());
};

var viewId = new Date().getTime();

var getViewId = function getViewId() {
  return viewId;
};

var resetViewId = function resetViewId() {
  viewId = new Date().getTime();
};

var generateRandom = function generateRandom() {
  return Math.floor(Math.random() * 1e10);
};

export { createNewGuid as default, createNewGuid, generateRandom, getViewId, resetViewId };
//# sourceMappingURL=guidGenerator.js.map